import type { AdminCrewReportUploadVesselDetailsProps } from "../../models/admin-crew-report.models";
import { twMerge } from "tailwind-merge";

const AdminCrewReportUploadVesselDetails = ({
  fileVesselImo,
  status,
  vesselDetails,
}: AdminCrewReportUploadVesselDetailsProps) => {
  if (!fileVesselImo) {
    return (
      <p
        className="border border-[#F2C6C7] bg-[#FFF4F4] px-3 py-2 text-xs font-semibold text-[#BF0002] dark:border-red-900/60 dark:bg-red-950/30"
        data-test="crew-report-upload-vessel-details"
      >
        A valid IMO.xlsx filename is required to resolve vessel details.
      </p>
    );
  }

  if (status === "resolving") {
    return (
      <p
        className="border border-gray-200 bg-[#F8FBFA] px-3 py-2 text-xs font-semibold text-[#637381] dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
        data-test="crew-report-upload-vessel-details"
      >
        Resolving vessel details for IMO {fileVesselImo}.
      </p>
    );
  }

  if (!vesselDetails?.recognized) {
    return (
      <p
        className="border border-[#F2C6C7] bg-[#FFF4F4] px-3 py-2 text-xs font-semibold text-[#BF0002] dark:border-red-900/60 dark:bg-red-950/30"
        data-test="crew-report-upload-vessel-details"
      >
        Vessel details were not resolved for this IMO number.
      </p>
    );
  }

  const details = [
    { label: "IMO", value: vesselDetails.imoNumber },
    { label: "Code", value: vesselDetails.vesselCode || "Not available" },
    { label: "Vessel", value: vesselDetails.vesselName || "Not available" },
    { label: "Type", value: vesselDetails.vesselType || "Not available" },
    { label: "Email", value: vesselDetails.vesselEmail || "Not available" },
  ];

  return (
    <dl
      className="grid min-w-0 grid-cols-1 gap-3 border border-[#DDE7E5] bg-[#F8FBFA] px-3 py-2 text-xs dark:border-gray-700 dark:bg-gray-900 sm:grid-cols-2 lg:grid-cols-5"
      data-test="crew-report-upload-vessel-details"
    >
      {details.map((detail) => (
        <div key={detail.label} className="min-w-0">
          <dt className="font-semibold uppercase text-[#637381] dark:text-gray-400">{detail.label}</dt>
          <dd
            className={twMerge(
              "truncate font-semibold text-[#1F2A29] dark:text-gray-100",
              detail.label === "Email" && "lg:max-w-[220px]",
            )}
            title={detail.value ?? ""}
          >
            {detail.value}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default AdminCrewReportUploadVesselDetails;
